import { makeStyles } from '@material-ui/core/styles'
import { Theme, MenuItem, Select } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import CaretDownIcon from '@src/icons/CaretDownIcon'

const useStyles = makeStyles((theme: Theme) => ({
  pageDropDownContainer: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(4),
    gap: theme.spacing(3),
  },
  pageSelect: {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightBold,
    boxShadow: 'none',
    '& .MuiSvgIcon-root': {
      top: 10,
      fontSize: theme.typography.pxToRem(12),
      '& svg': {
        color: theme.palette.primary.main,
      },
    },
    '& .MuiSelect-select:focus': {
      background: 'none',
    },
  },
  numberOfPages: {
    fontSize: theme.typography.pxToRem(16),
  },
}))
interface PageDropDownProps {
  currentPage: number
  handleChangePage: (event: React.ChangeEvent<{ value: unknown }>) => void
  numberOfPages: number
}
const PageSelectDropDown = ({
  currentPage,
  handleChangePage,
  numberOfPages,
}: PageDropDownProps) => {
  const classes = useStyles()
  const pages = Array.from({ length: numberOfPages }, (_, i) => i + 1)
  return (
    <div className={classes.pageDropDownContainer}>
      <div>
        <Select
          value={currentPage}
          onChange={handleChangePage}
          id="page-number-options"
          variant="standard"
          disableUnderline
          className={classes.pageSelect}
          IconComponent={CaretDownIcon}
        >
          {pages.map((sort) => (
            <MenuItem key={sort} value={sort} id={`page-option-${sort}`}>
              <FormattedMessage id="PAGE" defaultMessage="Page" /> {sort}
            </MenuItem>
          ))}
        </Select>
      </div>
      <div className={classes.numberOfPages}>of {numberOfPages}</div>
    </div>
  )
}

export default PageSelectDropDown
